import { updateProductDetails } from "../../../../../services/inventory";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import { getRandomIntInclusive } from "../../../../../helpers";
import { useContext, useEffect } from "react";
import { RequestLoader, ToastContext } from "../../../../../hooks/context";
import { useGetProductDetails } from "../../../../../hooks/api/queries/useInventory";
import { useMultipleImageUpload } from "../useMultipeImageUpload";

export const useEditProduct = () => {
  const params = useParams();
  const triggerToast = useContext(ToastContext);
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { isLoading, data: productDetails } = useGetProductDetails({
    id: params.id,
  });
  const { handleUploadMultipleMediaFiles } = useMultipleImageUpload();

  useEffect(() => {
    queryClient.invalidateQueries(["getProductDetails", params?.id]);
  }, [params, queryClient]);

  // update product function
  const { mutate: updateProduct, isLoading: isUpdatingProduct } = useMutation(
    (data) => updateProductDetails(data),
  );
  const handleProductUpdate = (submissionData) => {
    const { media_files } = submissionData;
    setRequestLoaderProgress(getRandomIntInclusive(10, 40));
    updateProduct(
      { submissionData, id: params.id },
      {
        onSuccess: () => {
          handleUploadMultipleMediaFiles({
            media_files: media_files,
            productId: params?.id,
            item_type: "product",
          });
          triggerToast("Product Updated Sucessfully", "success");
          queryClient.invalidateQueries(["getProductDetails", params?.id]);
          queryClient.invalidateQueries(["getProductList"]);
          navigate(-1);
        },
        onSettled: setRequestLoaderProgress(100),
      },
    );
  };

  return {
    isUpdatingProduct,
    isFetchingProduct: isLoading,
    productDetails,
    handleProductUpdate,
  };
};
